/* eslint-disable @typescript-eslint/no-unused-vars */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').directive('designerMap', [
    '$timeout',

    'DesignerMap',
    function ($timeout, DesignerMap) {
      return {
        templateNamespace: 'html',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer-map.html'),
        replace: true,
        scope: {
          designer: '=',
        },
        link(scope, element, attrs) {
          // set tootip after angular translate labels
          setTimeout(function () {
            element.find('[data-toggle=tooltip]').tooltip({
              animation: false,
              placement: 'left',
              trigger: 'hover',
            });
          });

          $timeout(function () {
            scope.designer.map.setElement(element);
          });

          $timeout(function (argument) {
            scope.$on(DESIGNER_EVENTS.PACKAGE_RESIZE, function (event, size) {
              scope.$apply();
            });
          }, 2000);

          let promise;

          scope.$on(DESIGNER_EVENTS.COMPONENT_SELECTION_CHANGED, function (event, size) {
            $timeout.cancel(promise);
          });
        },
      };
    },
  ]);
})(window.angular);
